module.exports = __webpack_public_path__ + "img/cross.ecbb8f6f.svg";